module.exports = __webpack_public_path__ + "static/media/clear-filter.ccb2bb09.svg";